module.exports = __webpack_public_path__ + "media/styles/images/svg/inline-arrow-up-teal-8a16b63baba769aece8e3cd294c930ea.svg";